import React from 'react';

import { CheckoutProgress } from '../../../../enums/checkout-progress.enum';
import { getEtherscanUrl } from '../../../../services/network.service';
import { centralEllipsis } from '../../../../utils/ellipsis.utils';
import CircleSpinner from '../../../circleSpinner/CircleSpinner';

import './CheckoutProgressModal.scss';

interface ICheckoutProgressModalProps {
  checkoutProgressStep: CheckoutProgress;
  transactionHash: string;
  venueAddress: string;
  venueName: string;
  venueShares: number;
  action: 'purchase' | 'bid accept' | 'bid';
}

const CheckoutProgressModal = ({
  checkoutProgressStep,
  transactionHash,
  venueAddress,
  venueName,
  venueShares,
  action,
}: ICheckoutProgressModalProps) => {
  const getProgressContent = (): React.ReactNode => {
    switch (checkoutProgressStep) {
      case CheckoutProgress.start:
        return <p>An unknown error occurred!</p>;
      case CheckoutProgress.inProgress:
        return (
          <div className="checkout-progress-modal__details">
            <p className="checkout-progress-modal__details-section">
              Your {action} of{' '}
              {venueShares} shares of{' '}
              <b>
                {venueName}{venueAddress ? ` (${venueAddress}) ` : ' '}
              </b>
              is processing.
              <br />
              It should be confirmed on the blockchain shortly.
            </p>
            <div className="checkout-progress-modal__details-section">
              <p>Transaction ID:</p>
              <a
                target="_blank"
                rel="noreferrer"
                className="checkout-progress-modal__hash-link"
                href={getEtherscanUrl(transactionHash)}
              >
                {centralEllipsis(transactionHash)}
              </a>
            </div>
          </div>
        );
      default:
        return <></>;
    }
  };

  return (
    <div className="checkout-progress-modal">
      <div className="checkout-progress-modal__spinner">
        {checkoutProgressStep === CheckoutProgress.inProgress && <CircleSpinner size={48} />}
      </div>
      <div className="checkout-progress-modal__content">{getProgressContent()}</div>
    </div>
  );
};

export default CheckoutProgressModal;
